module.exports = __webpack_public_path__ + "img/portrait-020.99f6322a.jpg";